import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { useTheme } from "react-native-paper";
import CustomHeader from "./CustomHeader";
import Settings from "../pages/Home/Settings";
import Therms from "../pages/Login/Therms";
import Language from "../pages/Home/Language";
import i18n from "../i18n";
import { mobUser } from "../mobx/MobUser";
import { observer } from "mobx-react";

const SettingsTabScreen = createNativeStackNavigator();

interface Route {
  name: string,
  component: () => JSX.Element,
  headerTitle: string,
  headerHasArrow: boolean,
  backPath?: string
}

const SettingsTabScreenScreen = observer(() => {
  const theme = useTheme();

  const ROUTES: Route[] = [
    { name: "Settings", component: Settings, headerTitle: i18n.t("home.settings"), headerHasArrow: false },
    { name: "Terms", component: Therms, headerTitle: i18n.t("home.terms"), headerHasArrow: true, backPath: "Settings" },
    { name: "Language", component: Language, headerTitle: i18n.t("home.language"), headerHasArrow: true, backPath: "Settings" },
  ];

  return (
    <SettingsTabScreen.Navigator 
      screenOptions={{
        statusBarColor: theme.colors.primary,
        navigationBarHidden: false,
        contentStyle: {
          backgroundColor: theme.colors.background
        }
      }}
    >
      {ROUTES.map((route: Route, index: number) => (
        <SettingsTabScreen.Screen
          key={index + mobUser.Language}
          name={route.name}
          component={route.component}
          options={{
            header: () => CustomHeader({ text: route.headerTitle, hasArrow: route.headerHasArrow, backPath: route.backPath, theme })
          }}
        />
      ))}
    </SettingsTabScreen.Navigator>
  );
});

export default SettingsTabScreenScreen;
